import React from "react";
import Modal from "../../../../components/common/Modal";

interface ProjectFormExampleModalProps {
  /** Controls whether the modal is visible */
  isOpen: boolean;
  /** Callback fired when the user closes the modal */
  onClose: () => void;
}

/**
 * ProjectFormExampleModal - Modal for displaying project form example images.
 *
 * Shows a sequence of example images for the Project Details form,
 * opened when the user clicks "here for an example of a completed form"
 * in the Project Page Help popup.
 *
 * @param isOpen - Whether the modal is currently visible.
 * @param onClose - Callback to close the modal.
 * @returns The project form example modal component.
 */
const ProjectFormExampleModal: React.FC<ProjectFormExampleModalProps> = ({
  isOpen,
  onClose,
}) => (
  <Modal
    isOpen={isOpen}
    title="Project Form Questions & Answers"
    onClose={onClose}
    onSecondary={onClose}
    clearBtn="Close"
    contentClassName="mb-4!"
  >
    <div className="flex flex-col gap-6 py-2">
      <img
        src="/assets/images/projects-details.png"
        alt="Project details form example"
        className="w-full rounded"
      />
      <img
        src="/assets/images/projects-details-add-new_1.png"
        alt="Add new project form example – part 1"
        className="w-full rounded"
      />
      <img
        src="/assets/images/projects-details-add-new_2.png"
        alt="Add new project form example – part 2"
        className="w-full rounded"
      />
    </div>
  </Modal>
);

export default ProjectFormExampleModal;
